/**
 * r95i-fix (set 2026) - Protezione contro estensioni/traduzione automatica
 * del browser (Google Translate, Safari Translate) che mutano il DOM gestito
 * da React avvolgendo i nodi testo in <font>. Alla successiva render React
 * crasha con NotFoundError su removeChild/insertBefore (visto in produzione
 * il 24/05 e 04/06, e riprodotto in preview il 03/09 con pagina tradotta).
 *
 * Workaround standard (React issue #11538): rendiamo removeChild e
 * insertBefore tolleranti - se il nodo di riferimento non e' piu' figlio
 * del parent atteso, logghiamo e degradiamo con grazia invece di lanciare.
 * Il DOM puo' restare visivamente imperfetto fino alla render successiva,
 * ma l'app non muore piu' con la schermata "Ops, qualcosa non ha funzionato".
 *
 * Importare PRIMA di ReactDOM (primo import in src/index.js).
 */
if (typeof Node === "function" && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      if (typeof console !== "undefined") {
        console.warn(
          "[domSafetyPatch] removeChild su nodo non figlio - probabile " +
            "traduzione automatica del browser attiva. Ignorato.",
        );
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (typeof console !== "undefined") {
        console.warn(
          "[domSafetyPatch] insertBefore con riferimento non figlio - " +
            "probabile traduzione automatica del browser attiva. Append in coda.",
        );
      }
      return originalInsertBefore.call(this, newNode, null);
    }
    return originalInsertBefore.apply(this, arguments);
  };
}
